import React, { Component } from "react";
import { Card, Modal, message, Tag, Spin, Typography, List } from "antd";
import { connect } from "react-redux";
import {
  getDateYYYYMM,
  formateHHMMSSDate,
  debounce,
  timestampToTime,
} from "../../utils/dateUtil";
import { usrRole, _uuid } from "../../utils/dataUtil";
import axios from "axios";
import {
  req_signle_pim_self,
  req_add_pim_bunchLog_in,
  req_add_pim_bunchLog_out,
  req_server_timestamp,
} from "../../api";
import "./blink-txt.css";
import BackFillSelfModal from "./back-fill-self-modal";
import OverTimeSelfModal from "./over-time-self-modal";
import WeekendOvertimeApplyModal from "./weekend-overtime-apply-modal";
import ClockLogSelf from "./clock-log-self";

const { Title } = Typography;
const { confirm } = Modal;
class OneDaySelf extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    time: "",
    deviceWidth: window.innerWidth,
    nowYearMonth: getDateYYYYMM(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    ip: "0.0.0.0",
    insideIPCheck: false,
    insertRow: {
      Uid: "",
      StaffCode: "",
      BunchDate: "",
      BunchTime: new Date(),
      BunchMessage: "SUCCESS",
      BunchStatus: "REALTIME",
      BunchType: "WEB",
      RecordIP: "0.0.0.0",
      NetworkStatus: "ALL",
      BackFillStatus: "NONE",
    },
    item: {},
    isShowBackFillModal: false,
    isShowOverTimeModal: false,
    isShowWeekendOvertimeApplyModal: false,
    antiShake: false,
    UIloading: true,
    ServerTime: "",
  };
  UNSAFE_componentWillMount() {
    clearInterval(this.intervalId);
    window.removeEventListener("resize", this.resize.bind(this));
  }

  componentDidMount() {
    this.api_item_list();
    this.api_server_time();
    setTimeout(() => {
      this.setState({ UIloading: false });
    }, 2500);
    this.updateTime();
    this.intervalId = setInterval(() => {
      this.updateTime();
    }, 1000);
    this.fetchIP();
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true });
    const result = await req_signle_pim_self(userLevel, userCode, token);
    if (result.total > 0) {
      const items = result.data;
      const antiShake = items[0].BunchTimeFirst !== null;
      this.setState({ data: items, loading: false, item: items[0], antiShake });
      console.log(items[0]);
    } else {
      const items = [];

      this.setState({
        data: items,
        loading: false,
        item: {},
      });
    }
  };
  api_server_time = async () => {
    const server_time = await req_server_timestamp();
    // console.log()
    // console.log(new Date())
    return timestampToTime(server_time);
  };

  api_add_item_bunchin = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_bunchLog_in(item, token);
    if (result.status === "success") {
      console.log(result);
      this.handle_data_refresh();
      message.success("已完成簽到");
    } else {
      message.error(result.message);
    }
  };

  api_add_item_bunchout = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_bunchLog_out(item, token);
    if (result.status === "success") {
      console.log(result);
      this.handle_data_refresh();
      message.success("已完成簽退");
    } else {
      message.error(result.message);
    }
  };

  // 格式轉換////////////////////////////////////////////////////
  // fetchIP = async () => {
  //   try {
  //     const response = await axios.get("https://api.ipify.org?format=json");
  //     this.setState({
  //       ip: response.data.ip,
  //       insideIPCheck: this.isIPInRange(response.data.ip),
  //     });
  //   } catch (error) {
  //     this.setState({ error: "Error fetching IP data" });
  //     console.error("Error fetching IP data:", error);
  //   }
  // };

  fetchIP = async () => {
    try {
      const response = await axios.get("https://ipinfo.io/json");
      this.setState({
        ip: response.data.ip,
        insideIPCheck: this.isIPInRange(response.data.ip),
      });
    } catch (error) {
      this.setState({ error: "Error fetching IP data" });
      console.error("Error fetching IP data:", error);
    }
  };

  ipToLong = (ip) => {
    return (
      ip
        .split(".")
        .reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0) >>> 0
    );
  };

  isIPInRange = (ip) => {
    if (ip === "0.0.0.0") return true; // 清楚允許 0.0.0.0
    const ipLong = this.ipToLong(ip);
    const range1Start = this.ipToLong("120.115.128.0");
    const range1End = this.ipToLong("120.115.223.255");
    const range2Start = this.ipToLong("192.192.3.0");
    const range2End = this.ipToLong("192.192.3.255");
    const range3Start = this.ipToLong("203.68.179.0");
    const range3End = this.ipToLong("203.68.185.255");

    return (
      (ipLong >= range1Start && ipLong <= range1End) ||
      (ipLong >= range2Start && ipLong <= range2End) ||
      (ipLong >= range3Start && ipLong <= range3End)
    );
  };

  formatTime = (timeString) => {
    const [daysStr, hoursStr] = timeString.split(",");
    const days = parseInt(daysStr, 10);
    const hours = parseInt(hoursStr, 10);

    let result = [];

    if (days > 0) {
      result.push(`${days}天`);
    }
    if (hours > 0) {
      result.push(`${hours}小時`);
    }

    return result.join("");
  };

  updateTime = () => {
    this.api_server_time().then((time) => {
      let currentTime =
        new Date(time.replace("(台北標準時間)", "")) || new Date();
      // 解析時間字串
      let hours = currentTime.getHours();
      let minutes = currentTime.getMinutes();
      let seconds = currentTime.getSeconds();

      // 檢查是否為NaN
      if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
        // 如果是NaN，改用當前的時間
        currentTime = new Date();
        hours = currentTime.getHours();
        minutes = currentTime.getMinutes();
        seconds = currentTime.getSeconds();
      }

      hours = (hours < 10 ? "0" : "") + hours;
      minutes = (minutes < 10 ? "0" : "") + minutes;
      seconds = (seconds < 10 ? "0" : "") + seconds;

      const timeString = hours + ":" + minutes + ":" + seconds;
      //console.log(timeString)
      this.setState({ time: timeString });
    });
  };

  extractTime(dateString) {
    const dateObject = new Date(dateString);
    const hours = dateObject.getHours().toString().padStart(2, "0");
    const minutes = dateObject.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  checkTime30Diff(time1String, time2String) {
    const time1 = new Date(time1String);
    const time2 = new Date(time2String);
    const diffTime = Math.abs(time2.getTime() - time1.getTime());
    const diffMinutes = diffTime / (1000 * 60);
    return diffMinutes === 30;
  }

  // 操作互動處理 //////////////////////////////////////////////
  handle_show_ui_modal = (modal, item) => {
    const {
      ClockDate,
      ClockOutTimeMust,
      ClockInTimeMustReal,
      ClockOutTimeMustReal,
      BunchTimeFirst,
      Uid,
      takeLeaveTimeHours,
    } = item;
    const insertRow = this.state.insertRow;
    // console.log(item);
    switch (modal) {
      case "view":
        break;
      case "BackFill":
        console.log("BackFillCase");
        this.setState({ item: item, isShowBackFillModal: true });
        break;
      case "BunchIn":
        console.log("BunchInCase");
        this.api_server_time().then((time) => {
          console.log(time);
          const nowBunchInTime =
            new Date(time.replace("(台北標準時間)", "")).toString() ===
            "Invalid Date"
              ? new Date()
              : new Date(time.replace("(台北標準時間)", ""));
          const nowstandardInTime = new Date(ClockInTimeMustReal);

          // console.log(nowBunchInTime, nowstandardInTime);
          if (nowBunchInTime < nowstandardInTime) {
            //早到
            //彈出提示
            confirm({
              title: "提前簽到", // Prompt message
              content:
                "依您本日標準作息簽到時間為 " +
                this.extractTime(nowstandardInTime) +
                "，若您現在 " +
                this.extractTime(nowBunchInTime) +
                "提早簽到，實際出勤初始時間，仍以標準作息簽到時間" +
                this.extractTime(nowstandardInTime) +
                "採計。仍欲簽到者請點選「確認」。",
              okText: "確認",
              cancelText: "取消",
              onOk: () => {
                if (this.state.antiShake) return;
                this.setState({ antiShake: true });
                this.bunchIn(item);
              },
              onCancel: () => {
                console.log("取消早到");
              },
            });
          } else {
            if (this.state.antiShake) return;
            this.setState({ antiShake: true });
            this.bunchIn(item);
          }
        });
        break;
      case "BunchOut":
        console.log("BunchOutCase");

        this.api_server_time().then((time) => {
          console.log("BunchOut");
          const currentTime =
            new Date(time.replace("(台北標準時間)", "")) || new Date();
          let standardInTime = new Date(ClockInTimeMustReal); // 標準簽到時間
          const WorkMinute = 8 * 60; // 學期標準工時8小時
          // const WorkMinute =
          // ClockOutTimeMust === "1200" ? 3 * 60 + 30 : 6 * 60 + 30; // 寒暑假標準工時 3.5 小時 或 6.5 小時
          const NoonRestMinute = 1 * 60; // 中午休息1小時
          const NightRestMinute = ClockOutTimeMust === "1200" ? 0 : 30; // 未到1700則夜間休息0分，反之為30分鐘
          const OverTimeMinute = 1; //最低加班1分
          let overworkTime = new Date();
          let alertTime = new Date();
          //let tempTime = new Date();
          console.log("標準簽到時間：", standardInTime);
          if (BunchTimeFirst == null) {
            //無簽到
            if (standardInTime.getHours() < 12) {
              //白日班
              standardInTime.setMinutes(
                standardInTime.getMinutes() +
                  WorkMinute +
                  NoonRestMinute +
                  NightRestMinute +
                  OverTimeMinute
              );
              alertTime = new Date(ClockOutTimeMustReal);
              // console.log("白日班");
            } else {
              // 午夜班
              standardInTime.setMinutes(
                standardInTime.getMinutes() +
                  WorkMinute +
                  NightRestMinute +
                  OverTimeMinute
              );
              alertTime = new Date(ClockOutTimeMustReal);
              // console.log("午夜班");
            }
            overworkTime = standardInTime;
            //console.log("未簽到-超時標準時間計算：", overworkTime);
          } else {
            //有簽到
            let bunchTimeFirst = new Date(BunchTimeFirst);
            let realInTime = new Date(BunchTimeFirst); //實際簽到時間
            let tempInTime = new Date(BunchTimeFirst); //計算簽退時間
            console.log("實際簽到時間：", realInTime);
            if (realInTime < standardInTime) {
              //提早簽到
              if (standardInTime.getHours() < 12) {
                //白日班
                standardInTime.setMinutes(
                  standardInTime.getMinutes() +
                    WorkMinute +
                    NoonRestMinute +
                    NightRestMinute +
                    OverTimeMinute
                );
                alertTime = new Date(ClockOutTimeMustReal);
              } else {
                // 午夜班
                standardInTime.setMinutes(
                  standardInTime.getMinutes() +
                    WorkMinute +
                    NightRestMinute +
                    OverTimeMinute
                );
                alertTime = new Date(ClockOutTimeMustReal);
              }
              overworkTime = standardInTime;
              console.log("提早簽到-超時標準時間計算：", overworkTime);
            } else {
              //超過標準簽到
              if (takeLeaveTimeHours == null) {
                // 未請假(部分時數)，用實際時間來計算
                if (standardInTime.getHours() < 12) {
                  //白日班
                  realInTime.setMinutes(
                    realInTime.getMinutes() +
                      WorkMinute +
                      NoonRestMinute +
                      NightRestMinute +
                      OverTimeMinute
                  );
                  if (bunchTimeFirst.getHours() < 12) {
                    tempInTime.setMinutes(
                      tempInTime.getMinutes() + WorkMinute + NoonRestMinute
                    );
                    alertTime = new Date(tempInTime);
                  } else {
                    alertTime = new Date(ClockOutTimeMustReal);
                  }
                } else {
                  // 午夜班
                  realInTime.setMinutes(
                    realInTime.getMinutes() +
                      WorkMinute +
                      NightRestMinute +
                      OverTimeMinute
                  );
                  alertTime = new Date(ClockOutTimeMustReal);
                }
                overworkTime = realInTime;
              } else {
                // 有請假(部分時數)，用標準時間來計算
                if (standardInTime.getHours() < 12) {
                  //白日班
                  standardInTime.setMinutes(
                    standardInTime.getMinutes() +
                      WorkMinute +
                      NoonRestMinute +
                      NightRestMinute +
                      OverTimeMinute
                  );
                  alertTime = new Date(ClockOutTimeMustReal);
                } else {
                  // 午夜班
                  standardInTime.setMinutes(
                    standardInTime.getMinutes() +
                      WorkMinute +
                      NightRestMinute +
                      OverTimeMinute
                  );
                  alertTime = new Date(ClockOutTimeMustReal);
                }
                overworkTime = standardInTime;
              }
              console.log("超過標準簽到-超時標準時間計算：", overworkTime);
            }
          }
          console.log("現在時間：", currentTime);
          console.log("超時標準：", overworkTime);
          console.log(currentTime > overworkTime);

          if (currentTime > overworkTime) {
            // 要詢問是否要加班
            this.setState({ item: item, isShowOverTimeModal: true });
          } else {
            if (alertTime <= currentTime) {
              //滿足彈班
              //直接簽退
              insertRow.Uid = _uuid();
              insertRow.BunchDate = ClockDate;
              //insertRow.BunchTime = new Date();
              insertRow.StaffCode = this.props.user.userCode;
              insertRow.RecordIP = this.state.ip;
              this.api_add_item_bunchout(insertRow);
            } else {
              //詢問是否想早退
              confirm({
                title: "簽退提示", // Prompt message
                content:
                  "依您今日簽到時間，本日滿足標準工時簽退時間應為 " +
                  this.extractTime(alertTime) +
                  "，若您有日內請假或為彈性班表者，可依規劃時間簽退。仍欲簽退者請點選「確認」。",
                okText: "確認",
                cancelText: "取消",
                onOk: () => {
                  // Handle early sign-out confirmation
                  insertRow.Uid = _uuid();
                  insertRow.BunchDate = ClockDate;
                  // insertRow.BunchTime = new Date();
                  insertRow.StaffCode = this.props.user.userCode;
                  insertRow.RecordIP = this.state.ip;
                  this.api_add_item_bunchout(insertRow);
                },
                onCancel: () => {
                  console.log("取消早退");
                },
              });
            }
          }
        });
        break;
      case "delete":
        Modal.confirm({
          title: `您確定刪除此筆`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_data_refresh = () => {
    this.api_item_list();
  };

  bunchIn = debounce((item) => {
    const { ClockDate } = item;
    const insertRow = this.state.insertRow;
    // 執行操作...
    //console.log(item);
    console.log("BunchIn_debounce");
    insertRow.Uid = _uuid();
    insertRow.BunchDate = ClockDate;
    insertRow.BackFillStatus = "NONE";
    //insertRow.BunchTime = new Date();
    insertRow.StaffCode = this.props.user.userCode;
    insertRow.RecordIP = this.state.ip;
    this.api_add_item_bunchin(insertRow);
  }, 2000);

  // 數據配置設定 //////////////////////////////////////////////

  // 渲染頁面 //////////////////////////////////////////////
  render() {
    const listdata = [
      "線上簽到退作業須於本校網域內進行，不能以行動裝置或使用校園無線網路進行簽到退。",
      "未到校前勿以其他方式完成簽到退，若藉由遠端桌面登入程式進行簽到退，經查證屬實，將依相關人事規定議處。",
      "每日工時應為8小時，正常工時每日不得超過12小時，簽退時間依彈性上班60分鐘內簽到時間而定。",
      "核定班表之工作日可於30分鐘前預簽到，實際出勤時間，以核定班別起始時間採計。",
      "工作日加班者，須於當日作息結束時間，再加休息30分鐘，始得申請加班起算時間。",
      "工作日加班時數至多4小時，每月延長工時總時數不得超過46小時。",
      "職工每周最多六天上班，若有休假日申請上班者，應留意是否造成連續七天上班。",
      "工作日與休息日申請調換，應為整日調換。",
      "單日彈班申請及加班申請，須經單位主管事前同意，並於系統內提出申請。",
      "個人或部門有彈性班表需求如有疑問，請洽人事室(蔡小姐TEL:224)辦理；或對本系統功能建議亦可提出。",
    ];
    const {
      data,
      ip,
      insideIPCheck,
      isShowBackFillModal,
      isShowOverTimeModal,
      isShowWeekendOvertimeApplyModal,
      item,
      antiShake,
    } = this.state;
    // console.log(data[0]);
    if (this.state.UIloading) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Spin tip="簽到退紀錄檢核中"></Spin>
        </div>
      );
    }
    return (
      <Card>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {data.length > 0 ? (
            <div>
              <>
                {insideIPCheck ? (
                  <>
                    {data[0].WorkStatus === "PASS" ? (
                      <Tag color="green">本日為休息日，無須簽到退</Tag>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <div>
                          <Tag
                            color={
                              data[0].WorkStatus === "WORK"
                                ? "#483D8B"
                                : "#B22222"
                            }
                          >
                            {" "}
                            {data[0].WorkReason}
                          </Tag>

                          {data[0].ClockType === "FLEXIBLE" ? (
                            <Tag color="blue">彈</Tag>
                          ) : (
                            ""
                          )}
                          {data[0].ClockType === "OVERTIME" ? (
                            <Tag color="red">加</Tag>
                          ) : (
                            ""
                          )}
                        </div>
                        <div>
                          <span
                            style={{
                              fontWeight: 900,
                              fontSize: "4.0em",
                              color:
                                data[0].WorkStatus === "PASS"
                                  ? "#B22222"
                                  : "#483D8B",
                            }}
                          >
                            {data[0].ClockDate} {data[0].WeekdayName}
                          </span>
                        </div>
                        <div
                          style={{
                            fontWeight: 900,
                            fontSize: "4.0em",
                            color: "#f54f07",
                          }}
                        >
                          {this.state.time}
                        </div>
                        <div>
                          <button
                            className={
                              antiShake
                                ? "btn btn-success btn-md"
                                : "btn btn-warning btn-md"
                            }
                            style={{ marginRight: "5px", minWidth: "70px" }}
                            disabled={antiShake}
                            onClick={() =>
                              this.handle_show_ui_modal("BunchIn", item)
                            }
                          >
                            <i className="fas fa-sign-in-alt"></i> 簽到
                          </button>
                          {""}
                          <button
                            className={
                              data[0].BunchTimeLast !== null
                                ? "btn btn-success btn-md"
                                : "btn btn-warning btn-md"
                            }
                            style={{ minWidth: "70px" }}
                            disabled={data[0].BunchTimeLast !== null}
                            onClick={() =>
                              this.handle_show_ui_modal("BunchOut", item)
                            }
                          >
                            <i className="fas fa-sign-out-alt"></i> 簽退
                          </button>
                        </div>

                        <div style={{ marginTop: "10px" }} className="blink">
                          <span
                            style={{
                              fontWeight: 900,
                              fontSize: "1.2em",
                              color: "#750008",
                            }}
                          >
                            {data[0].BunchTimeFirst != null ? (
                              <>
                                <span>已簽紀錄：</span>
                                {formateHHMMSSDate(data[0].BunchTimeFirst)}
                                {data[0].BackFillStatusFirst === "NONE" ? (
                                  ""
                                ) : (
                                  <Tag
                                    color="volcano"
                                    style={{ marginLeft: "5px" }}
                                  >
                                    補
                                  </Tag>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                            {data[0].BunchTimeLast != null ? (
                              <>
                                <>-</>
                                {formateHHMMSSDate(data[0].BunchTimeLast)}
                                {data[0].BackFillStatusLast === "NONE" ? (
                                  ""
                                ) : (
                                  <Tag
                                    color="volcano"
                                    style={{ marginLeft: "5px" }}
                                  >
                                    補
                                  </Tag>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                        <div>
                          <span>
                            {data[0].takeLeaveType != null
                              ? data[0].takeLeaveType
                              : ""}
                            {data[0].takeLeaveType != null
                              ? this.formatTime(data[0].takeLeaveTimeHours)
                              : ""}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <Tag color="red">非校內IP不能簽到退</Tag>
                )}
              </>
            </div>
          ) : (
            <div style={{ width: "100%" }}>
              <ClockLogSelf />
            </div>
          )}
          <div
            style={
              insideIPCheck
                ? {
                    fontSize: "0.8em",
                    color: "green",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }
                : {
                    fontSize: "0.8em",
                    color: "red",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }
            }
          >
            {ip}
            {insideIPCheck ? "內網" : "外網"}
          </div>
          <p style={{ fontSize: "0.8em", color: "gray" }}>
            註：簽到退紀錄以本系統計時介面(伺服器時間)為準
          </p>
          <div>
            <a
              href="https://www.canva.com/design/DAGgLnKc0bo/84ETfdpvL8XCXk57V0IboA/view?utm_content=DAGgLnKc0bo&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h4778d5c2cc/"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary btn-sm"
            >
              <i className="fas fa-book"></i> 操作手冊
            </a>
          </div>
        </div>
        <div style={{ maxWidth: 800, margin: "auto" }}>
          <Title level={2} style={{ color: "gray" }}>
            <i className="fas fa-thumbtack" style={{ marginRight: "5px" }}></i>
            注意事項
          </Title>
          <List
            // header={<div>Header</div>}
            // footer={<div>Footer</div>}
            bordered
            dataSource={listdata}
            renderItem={(item, index) => (
              <List.Item>
                <span style={{ fontWeight: "bold", color: "gray" }}>
                  {index + 1}.{item}
                </span>
              </List.Item>
            )}
          />
        </div>
        <Modal
          destroyOnClose={true}
          visible={isShowBackFillModal}
          width={250}
          onOk={() => {
            this.setState({ isShowBackFillModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowBackFillModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <BackFillSelfModal data={item} ip={ip} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowOverTimeModal}
          width={400}
          onOk={() => {
            this.setState({ isShowOverTimeModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowOverTimeModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <OverTimeSelfModal
            data={item}
            ip={ip}
            onSuccess={() => {
              this.setState({ isShowOverTimeModal: false });
              this.handle_data_refresh();
            }}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowWeekendOvertimeApplyModal}
          width={300}
          onOk={() => {
            this.setState({ isShowWeekendOvertimeApplyModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowWeekendOvertimeApplyModal: false });
            this.handle_data_refresh();
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <WeekendOvertimeApplyModal />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(OneDaySelf);
